import { render, staticRenderFns } from "./Component-VideoMonitorControl.vue?vue&type=template&id=1680f2e6&"
import script from "./Component-VideoMonitorControl.vue?vue&type=script&lang=js&"
export * from "./Component-VideoMonitorControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports